<template>
  <div class="animated fadeIn">
    <b-card>
      <template slot="header">
        <i class='fa fa-align-justify'></i> CRS List
      </template>

      <b-card v-show="so.adv">
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label>Registed_at</label>
              <b-form inline>
                <date-picker class="mt-2 mr-2" v-model="so.opt.created_at_sd" style="width: 140px" :confirm="true" :first-day-of-week="1" @keyup.enter="refresh"></date-picker>
                ~
                <date-picker class="ml-2" v-model="so.opt.created_at_ed" style="width: 140px" :confirm="true" :first-day-of-week="1" @keyup.enter="refresh"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group class="float-right">
          <b-button class= "mr-1" size="sm" variant="danger" @click="so.adv = false"> Close </b-button>
          <b-button class= "mr-1" size="sm" variant="light" @click="resetField"> Reset </b-button>
          <b-button size="sm" variant="primary" @click="refresh"> Search </b-button>
        </b-form-group>
      </b-card>

      <b-row>
        <b-col>
          <b-form-fieldset style="width : 120px;" size="sm">
            <b-form-select :options="so.pageoptions" v-model="so.perPage">
            </b-form-select>
          </b-form-fieldset>
        </b-col>
        <b-col>
          <b-input-group style="width : 90%" size="sm" class= "float-right">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :text="so.skt || 'Search'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='site';so.skt='site'">Site</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='company';so.skt='company'">Company</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
            <b-input v-model="so.sv" @keyup.enter="refresh()"></b-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary" @click="so.adv = !so.adv"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>

      <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found"
        :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
        <template #cell(id)="row">{{row.item.id}}</template>
        <template #cell(is_use)="row">
          <b-badge variant="success" v-if="row.item.is_alive">Enable</b-badge>
          <b-badge v-else variant="secondary">Disable</b-badge>
        </template>
        <template #cell(is_publish)="row">
          <b-badge variant="primary" v-if="row.item.is_publish">Deployed</b-badge>
          <b-badge v-else variant="secondary">-</b-badge>
        </template>
        <template #cell(version)="row">
          <a href="javascript:void();" @click="detail(row.item)">{{ row.item.version || '-' }}</a>
        </template>
        <!-- <template #cell(company)="row">{{row.item.company}}</template> -->
        <template #cell(created_at)="row">{{row.item.created_at | datetime2}}</template>
      </b-table>

      <b-row>
        <b-col>
        </b-col>
        <b-col class="mt-1 d-flex justify-content-center">
          <b-pagination size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" prev-text="Prev" next-text="Next"/>
        </b-col>
        <b-col v-if="profile.permission == 'Master'">
          <div class="pull-right">
            <b-button class= "m-1" size="sm" variant="success" @click="$router.push({ name: 'uwss_crs', params: { id : 'add' } })"> Create </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import vSelect from 'vue-select';
// import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import datepicker from '@/f1/custom';
import { api, auth } from '@/f1/service';
import 'vue2-datepicker/index.css';

const default_opt = () => ({
  perPage: 25,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv: false,
  pageoptions : [
    {text:'10 rows',value:10},
    {text:'25 rows',value:25},
    {text:'50 rows',value:50},
    {text:'100 rows',value:100},
    {text:'200 rows',value:200}
  ]
});

export default {
  components: { DatePicker, vSelect },
  data: () => ({
    datepicker,
    so : default_opt(),
    profile : auth.profile
  }),
  computed: {
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      return [
        { key: 'id', thStyle: 'width: 10%', sortable: true, label: 'No' },
        { key: 'is_use', sortable: true, label: 'Enable' },
        { key: 'version', sortable: true, label: 'Version' },
        { key: 'agent_version', sortable: true, label: 'Support Agent Minimum' },
        { key: 'is_publish', sortable: true, label: 'Publish Status' },
        { key: 'count', sortable: true, label: 'Total' },
        { key: 'created_at', sortable: true, label: 'Registed_at' }
    ]}
  },
  methods: {
    resetField(){ this.so = default_opt(); this.refresh(); this.so.adv = !this.so.adv},
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { this.$refs._list.refresh(); },
    getRowCount () { return this.so.totalRows || 0; },
    getItems(ctx) { return this.load(ctx); },
    async load(ctx = {}) {
      let so = {
        ok : ctx.sortBy,
        od : ctx.sortDesc ? 'd' : 'a',
        pg : ctx.currentPage || this.so.currentPage || 1,
        pc : ctx.perPage || this.so.perPage || 10,
        sk : this.so.sk || 'site',
        sv : this.so.sv,
        opt: this.so.adv ? Object.assign({}, this.so.opt) : {}
      }
      // Build all
      var search = { limit: so.pc, offset: (so.pg - 1) * so.pc, and: [], or: [], sort: [] }
      // order
      if(so.ok) { search.sort.push({name: so.ok, op: so.od == 'd' && 'desc' }); }
      // search
      if(so.sk && so.sv) {
        if(!so.ok){
          search.sort.push({name: so.sk, op: so.od == 'd' && 'desc' });
        }
        search.or.push({name: so.sk, value: `%${so.sv}%`, op:'like'});
      }
      // search (adv)
      for (let [key, value] of Object.entries(so.opt)) {
        if(value != null && value != ""){
          switch(key) {
            case 'created_at_sd' : search.and.push({name: 'created_at', value: new Date(value), op: '>=' }); break;
            case 'created_at_ed' : var d = new Date(value); d.setDate(d.getDate() + 1); search.and.push({name: 'created_at', value: d, op: '<' }); break;
            default: search.and.push({name: key, value: `%${value}%`, op: 'like' }); break;
          }
        }
      }

      try { let rs = await api.uwss.crs.list(search); this.so.totalRows = rs.count; return rs.result; }
      catch(e) { this.$toastr.e(e.data || e); }
    },
    detail(item) { this.$router.push(`/uwss/crs/${item.id}`); },
  },
  created() { },
  destroyed() { },
  mounted() {  },
}
</script>
